import {Component} from '@angular/core';

@Component({
  selector: 'app-layout-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['../../../monitor.scss']
})
export class FooterComponent {
  today: number = Date.now();
}
